import SuccessGif from 'assets/success-gif.png';
import React from 'react';

export interface ISuccessBox {
  text: string;
  children?: React.ReactNode;
}

const SuccessBox = ({ text, children }: ISuccessBox) => {
  return (
    <div className='max-w-lg flex flex-col justify-center items-center gap-[16px]'>
      <img src={SuccessGif} />
      <div className='bold text-grey800 font-[DKLiquidEmbrace] text-3xl text-center'>{text}</div>
      {children}
    </div>
  );
};

export default SuccessBox;
